import React, { useEffect, useState } from 'react';

function LogModal({ activeLog, setActiveLog }) {
  const [fileContent, setFileContent] = useState('');

useEffect(() => {
  if (activeLog?.result) {
    try {
      const parsed = typeof activeLog.result === "string" ? JSON.parse(activeLog.result) : activeLog.result;
      const pretty = JSON.stringify(parsed, null, 2);
      setFileContent(pretty);
    } catch (err) {
      setFileContent(activeLog.result);
    }
  }
}, [activeLog]);


  if (!activeLog) return null;

  return (
    <div
      className="modal"
      onClick={() => setActiveLog(null)}
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        background: 'rgba(0,0,0,0.5)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 1050,
      }}
    >
      <div
        className="modal-content"
        onClick={(e) => e.stopPropagation()}
        style={{
          background: 'white',
          padding: '2rem',
          borderRadius: '10px',
          width: '90%',
          maxWidth: '900px',
          maxHeight: '80vh',
          overflowY: 'auto',
        }}
      >
        <button
          className="btn btn-sm btn-dark"
          onClick={() => setActiveLog(null)}
          style={{ float: 'right' }}
        >
          ×
        </button>
        <h5 className="mb-3">{activeLog.filename}</h5>
        <div
          style={{
            backgroundColor: '#f8f9fa',
            padding: '1rem',
            borderRadius: '8px',
            whiteSpace: 'pre-wrap',
            wordBreak: 'break-word',
            fontFamily: 'monospace',
            fontSize: '0.9rem',
            border: '1px solid #ddd',
          }}
        >
          {fileContent}
        </div>
      </div>
    </div>
  );
}

export default LogModal;
